import { apiCall } from "./service";
import { BASE_URL } from "./URL";

const getProjectBase = (projectId) => `${BASE_URL}projects/${projectId}/`;

export const api = {
  // ── List (used by saga) ─────────────────────────────────────────────────
  getReshuffleRequests(params) {
    const { projectId, page, size, search, status } = params;
    const query = new URLSearchParams({ pageNumber: page, pageSize: size });
    if (search) query.append("searchTerm", search);
    if (status !== undefined && status !== null) query.append("status", status);
    return apiCall.pagination({
      url: `${getProjectBase(projectId)}reshuffle-requests?${query}`,
    });
  },

  updateReshuffleRequestFlagRequest(params) {
    const { projectId, id, payload } = params;
      return apiCall.patch({ 
        url: `${getProjectBase(projectId)}reshuffle-requests/${id}`,  
        params: payload });
    },

  // ── Mutations (used by sagas) ────────────────────────────────────────────
  createReshuffleRequest(params) {
    const { projectId, payload } = params;
    return apiCall.post({
      url: `${getProjectBase(projectId)}reshuffle-requests`,
      params: payload,
    });
  },

  updateReshuffleRequest(params) {
    const { projectId, id, payload } = params;
    return apiCall.put({
      url: `${getProjectBase(projectId)}reshuffle-requests/${id}`,
      params: payload,
    });
  },

  submitReshuffleRequest(params) {
    const { projectId, id } = params;
    return apiCall.post({
      url: `${getProjectBase(projectId)}reshuffle-requests/${id}/submit`,
    });
  },

  approveReshuffleRequest(params) {
    const { projectId, id, reviewNotes } = params;
    return apiCall.post({
      url: `${getProjectBase(projectId)}reshuffle-requests/${id}/approve`,
      params: { reviewNotes: reviewNotes || "" },
    });
  },

  rejectReshuffleRequest(params) {
    const { projectId, id, reviewNotes } = params;
    return apiCall.post({
      url: `${getProjectBase(projectId)}reshuffle-requests/${id}/reject`,
      params: { reviewNotes: reviewNotes || "" },
    });
  },

  executeReshuffleRequest(params) {
    const { projectId, id } = params;
    return apiCall.post({
      url: `${getProjectBase(projectId)}reshuffle-requests/${id}/execute`,
    });
  },

  cancelReshuffleRequest(params) {
    const { projectId, id } = params;
    return apiCall.post({
      url: `${getProjectBase(projectId)}reshuffle-requests/${id}/cancel`,
    });
  },

  deleteReshuffleRequest(params) {
    const { projectId, id } = params;
    return apiCall.delete({
      url: `${getProjectBase(projectId)}reshuffle-requests/${id}`,
    });
  },

  // ── Direct calls (consumed by component, not sagas) ─────────────────────
  getSingleReshuffleRequest(projectId, id) {
    return apiCall.get({
      url: `${getProjectBase(projectId)}reshuffle-requests/${id}`,
    });
  },

  getReshuffleSummary(projectId, id) {
    return apiCall.get({
      url: `${getProjectBase(projectId)}reshuffle-requests/${id}/summary`,
    });
  },

  getReshuffleOptions(projectId, params) {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null) query.append(k, v);
    });
    return apiCall.get({
      url: `${getProjectBase(projectId)}reshuffle-options?${query}`,
    });
  },

  validateReshuffleRequest(projectId, payload) {
    return apiCall.post({
      url: `${getProjectBase(projectId)}reshuffle-requests/validate`,
      params: payload,
    });
  },
};

export default api;
